export default function Brands() {
    const brands = [
        {
            name: 'Jonnesway',
            logo: 'https://www.pride.ru/images/logos/jonnesway.svg',
            link: 'https://jonnesway.ru/page/about/'
        },
        {
            name: 'Ombra',
            logo: 'https://www.pride.ru/images/logos/ombra.svg',
            link: 'https://ombratools.ru/about/'
        },
        {
            name: 'Thorvik',
            logo: 'https://www.pride.ru/images/logos/thorvik.svg',
            link: 'https://thorvik.ru/about'
        },
        {
            name: 'Carbon',
            logo: 'https://www.pride.ru/images/logos/carbon2.svg',
            link: 'https://carbontools.ru/about'
        },
        {
            name: 'FILL Inn',
            logo: 'https://www.pride.ru/images/logos/fillinn.svg',
            link: 'https://fill-inn.com/page/about/'
        },
        {
            name: 'Rotake',
            logo: 'https://www.pride.ru/images/logos/rotake.svg',
            link: 'https://rotakepro.ru/#brand'
        }
    ];

    return (
        <div className="provider">
            <div className="container">
                <h2 className="t-two provider__title">
                    Один из крупнейших в России поставщиков профессионального слесарно-монтажного инструмента
                </h2>
                <div className="row g-3 g-sm-4 gx-lg-6 gy-lg-6 provider__row">
                    {brands.map((brand, index) => (
                        <div key={index} className="col-xxl-3 col-12 col-lg-4 col-sm-6 provider__item">
                            <div className="d-flex flex-column align-items-center provider__i-body">
                                <div className="provider__i-logo">
                                    <img className="h-auto w-auto" src={brand.logo} alt={brand.name}/>
                                </div>
                                {/*<div className="t-two provider__i-title">*/}
                                {/*    {brand.name}*/}
                                {/*</div>*/}
                                <a href={brand.link} target="_blank" rel="noopener noreferrer" className="bs-link provider__i-link">
                                    Подробнее о бренде
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                {/*<button className="d-flex align-items-center btn btn-primary justify-content-end provider__btn">*/}
                {/*    <span>Каталог →</span>*/}
                {/*</button>*/}
            </div>
        </div>
    );
}